<template>
  <transition name="vmenu-fade">
    <div
      v-if="isActive"
      @click="handleShadowClicked"
      class="vmenu-shadow"
    ></div>
  </transition>
</template>

<script>
export default {
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    handleShadowClicked: {
      type: Function,
      default: () => {}
    }
  }
}
</script>

<style lang="postcss">
.vmenu-shadow {
  @apply absolute left-0 w-full h-screen z-10 opacity-50 bg-body-dark;
  top: 62px;
}
.vmenu-fade-enter-active,
.vmenu-fade-leave-active {
  transition: opacity 0.5s;
}
.vmenu-fade-enter,
.vmenu-fade-leave-to {
  @apply opacity-0;
}
</style>
